import React from "react";
import PropTypes from "prop-types";
import glamorous from "glamorous";

// TODO: figure out how to allow implementers to customize the container; themeing? glamor?
const ContainerDiv = glamorous.div(
  {
    height: 6,
    width: "100%",
    backgroundColor: "#999999"
  },
  props => {
    let displayAttribs = {};
    if (!props.display) {
      displayAttribs = {
        display: "flex",
        flexDirection: "row"
      };
    }
    const { height, width, backgroundColor } = props;
    return {
      ...displayAttribs,
      height,
      width,
      backgroundColor
    };
  }
);

const StepDiv = glamorous.div({
  height: "100%",
  flexGrow: 1,
  textAlign: "center"
});

const StepColorDiv = glamorous.div(
  {
    height: "100%",
    transition: "width 1s ease"
  },
  props => {
    return {
      width: props.completed ? "100%" : 0,
      backgroundColor: props.active ? "#00AD50" : "#000000",
      color: props.completed ? "#333333" : "#969696"
    };
  }
);

const ProgressHeader = glamorous.h1({
  fontWeight: "normal",
  marginTop: 0,
  fontSize: "1.3rem",
  color: "#757575"
});

const ProgressIndicator = props => {
  const {
    steps,
    activeIndex,
    showLabels = true,
    progressUnit = "Step",
    ...restProps
  } = props;
  return (
    <div>
      <ProgressHeader>
        {progressUnit} {activeIndex + 1} of {steps.length}
      </ProgressHeader>
      <ContainerDiv {...restProps}>
        {steps.map((step, index) => {
          return (
            <StepDiv
              key={`step-${index + 1}`}
              onClick={
                typeof step.onClick === "function" ? step.onClick(step) : null
              }
            >
              <StepColorDiv
                completed={index <= activeIndex}
                active={index === activeIndex}
                stepColor={"#696969"}
              >
                {showLabels ? step.title : null}
              </StepColorDiv>
            </StepDiv>
          );
        })}
      </ContainerDiv>
    </div>
  );
};

ProgressIndicator.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      onClick: PropTypes.func
    })
  ),
  showLabels: PropTypes.bool,
  progressUnit: PropTypes.string
};

export default ProgressIndicator;



// WEBPACK FOOTER //
// ./src/App/account/components/ProgressIndicator/index.js